import Opd from 'locales/dental/th/dentist/opd.json'
import PdfInvoic from 'locales/dental/th/dentist/pdfInvoice.json'
import PdfStickerMed from 'locales/dental/th/dentist/pdfStickerMed.json'
import Summary from 'locales/dental/th/dentist/summary.json'
import TreatmentDocument from 'locales/dental/th/dentist/treatmentDocument.json'
import Treatments from 'locales/dental/th/dentist/treatments.json'
import treatmentsDx from 'locales/dental/th/dentist/treatmentsDx.json'
import Emr from 'locales/dental/th/dentist/treatmentsEmr.json'
import Product from 'locales/dental/th/dentist/treatmentsProduct.json'
import TreatmentQueue from 'locales/dental/th/dentist/treatmentsQueue.json'
import Tx from 'locales/dental/th/dentist/treatmentsTx.json'
import TreatmentsTxc from 'locales/dental/th/dentist/treatmentsTxc.json'
import TreatmentsTxp from 'locales/dental/th/dentist/treatmentsTxp.json'
import vitalSign from 'locales/dental/th/dentist/treatmentsVital-sign.json'
import TxInformationBox from 'locales/dental/th/dentist/txInFormationBox.json'
import Xray from 'locales/dental/th/dentist/xray.json'

export const Treatment = {
  ...TreatmentQueue,
  ...Treatments,
  ...vitalSign,
  ...treatmentsDx,
  ...Summary,
  ...Opd,
  ...Tx,
  ...Product,
  ...Emr,
  ...TreatmentDocument,
  ...TxInformationBox,
  ...TreatmentsTxp,
  ...TreatmentsTxc,
  ...PdfStickerMed,
  ...Xray,
  ...PdfInvoic
}
